module.exports = __webpack_public_path__ + "static/media/back.e1ceea04.svg";